// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"aa9d652f","102":"6cf9dbea","162":"2a8f25f7","239":"10ef1799","488":"fa74d79d","667":"cd734704","777":"0468bf0d","826":"73ecfdd9","901":"7906da10","977":"771c640a"}[chunkId] + ".chunk.js";
};